import React, { Component } from 'react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // You can log the error or handle it as needed
    console.error('Error:', error);
    console.error('Error info:', info);

    this.setState({ hasError: true });
  }

  render() {
    if (this.state.hasError) {
      return <div>Error occurred. Please try again later.</div>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
